import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Box, Button } from '@mui/material';

export interface CreatePromotionButtonProps {
  strings?: {
    addPromotion: string;
  };
  onClick: () => void;
}

const useStrings = (): CreatePromotionButtonProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      addPromotion: intl.formatMessage({ id: 'components.CreatePromotionButton.addPromotion' }),
    }),
    [intl],
  );
};

export const CreatePromotionButton = ({ onClick }: CreatePromotionButtonProps) => {
  const strings = useStrings();

  return (
    <Box display="flex">
      <Button
        onClick={onClick}
        variant="contained"
        color="primary"
        type="submit"
        sx={{
          width: '79px',
          height: '36px',
          display: 'flex',
          flexDirection: 'row',
          padding: '8px 16px',
          gap: '8px',
          minWidth: 0,
          fontSize: '14px',
        }}
      >
        {strings.addPromotion}
      </Button>
    </Box>
  );
};
